module.exports = __webpack_public_path__ + "img/DsIcon-ArrowUp.723cbd81.svg";